import React, { useEffect, useRef, useState } from "react";
import { Paper } from "@material-ui/core";
import { baseUrl } from "../../../services/config";
import ReactToPrint from "react-to-print";
import Select from "react-select";
import "./GrossSalary.css";
import { Spinner, Table } from "react-bootstrap";
import PasswordModal from "../../../components/PasswordModal/PasswordModal";
import { useAlert } from "react-alert";
import GrossSalarySheetExport from "./GrossSalarySheetExport";
import { upperCase } from "lodash";
import { useSelector } from "react-redux";

const GrossSalarySheet = () => {
  // const loginAccount = JSON.parse(localStorage.getItem("userDetails")).role[0];
  let authtoken = localStorage.getItem("userToken");
  const alert = useAlert();
  const pageStyle = `
  @page {
    margin-left: 1.5in;
        size: legal landscape !important;
    }
`;
  const [month, setMonth] = useState("");
  const user = useSelector((state) => state.user.user);
  const [campusData, setCampusData] = useState(user.campuses || []);
  const [campus, setCampus] = useState([]);
  const [reportData, setReportData] = useState([]);
  const [fullCampus, setFullCampus] = useState({});
  const [loading, setloading] = useState(false);
  const [selectType, setSelectType] = useState("");
  const [selectGroup, setSelectGroup] = useState("");
  const [glossTotal, setGlossTotal] = useState("");
  const [netTotal, setNetTotal] = useState("");
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);

  const [isVisible, setIsVisible] = useState(false);

  const [TotalBasicPay, setTotalBasicPay] = useState(0);
  const [TotalIncrement, setTotalIncrement] = useState(0);
  const [TotalBSAllow, setTotalBSAllow] = useState(0);
  const [TotalAdpAllow, setTotalAdpAllow] = useState(0);
  const [TotalAdditional, setTotalAdditional] = useState(0);
  const [TotalExtraPeriod, setTotalExtraPeriod] = useState(0);
  const [Total2ndShift, setTotal2ndShift] = useState(0);
  const [TotalDPTAllow, setTotalDPTAllow] = useState(0);
  const [TotalCollege, setTotalCollege] = useState(0);
  const [TotalHostel, setTotalHostel] = useState(0);
  const [TotalInvDuty, setTotalInvDuty] = useState(0);
  const [TotalNavttc, setTotalNavttc] = useState(0);
  const [TotalConva, setTotalConva] = useState(0);
  const [TotalInterAllow, setTotalInterAllow] = useState(0);
  const [TotalGrossSalary, setTotalGrossSalary] = useState(0);
  const [TotalAnnualIncr, setTotalAnnualIncr] = useState(0);

  // Get the current date
  const currentDate = new Date();

  // Format the date as a string
  const formattedDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "long",
  }).format(currentDate);

  const displayDate = currentDate.toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });

  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  useEffect(() => {
    getSettingData();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  //for print
  const handleBeforePrint = React.useCallback(() => {}, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {}, []);

  const onShow = () => {
    if (campus == "") {
      alert.error("Please Select Campus");
      return;
    }

    let data = {
      campus_id: campus,
    };
    setloading(true);

    fetch(`${baseUrl}/staff_gross_salary_report`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) =>
        res.json().then((data) => {
          setloading(false);
          setIsVisible(true);

          if (data.metadata) {
            if (data.metadata.success) {
              let sumBasicPay = 0;
              data.payload.map((item) => {
                if (item.pay_scale == null) {
                  sumBasicPay += 0;
                } else {
                  sumBasicPay += parseInt(item?.pay_scale?.basic);
                }
              });
              setTotalBasicPay(sumBasicPay);

              let sumIncrement = 0;
              data.payload.map((item) => {
                if (item.salaryAlowance == null) {
                  sumIncrement += 0;
                } else {
                  sumIncrement += parseInt(item?.salaryAlowance?.increment);
                }
              });
              setTotalIncrement(sumIncrement);

              let sumBS = 0;
              data.payload.map((item) => {
                if (item.salaryAlowance == null) {
                  sumBS += 0;
                } else {
                  sumBS += parseInt(item?.salaryAlowance?.bs_allowance);
                }
              });
              setTotalBSAllow(sumBS);

              let sumAdp = 0;
              data.payload.map((item) => {
                if (item.salaryAlowance == null) {
                  sumAdp += 0;
                } else {
                  sumAdp += parseInt(item?.salaryAlowance?.adp_allowance);
                }
              });
              setTotalAdpAllow(sumAdp);

              let sumAddAlown = 0;
              data.payload.map((item) => {
                if (item.salaryAlowance == null) {
                  sumAddAlown += 0;
                } else {
                  sumAddAlown += parseInt(
                    item?.salaryAlowance?.additional_allowance,
                  );
                }
              });
              setTotalAdditional(sumAddAlown);

              let sumExtraPer = 0;
              data.payload.map((item) => {
                if (item.salaryAlowance == null) {
                  sumExtraPer += 0;
                } else {
                  sumExtraPer += parseInt(item?.salaryAlowance?.extra_period);
                }
              });
              setTotalExtraPeriod(sumExtraPer);

              let sum2ndShift = 0;
              data.payload.map((item) => {
                if (item.salaryAlowance == null) {
                  sum2ndShift += 0;
                } else {
                  sum2ndShift += parseInt(item?.salaryAlowance?.second_shift);
                }
              });
              setTotal2ndShift(sum2ndShift);

              let sumDPT = 0;
              data.payload.map((item) => {
                if (item.salaryAlowance == null) {
                  sumDPT += 0;
                } else {
                  sumDPT += parseInt(item?.salaryAlowance?.dpt_allowance);
                }
              });
              setTotalDPTAllow(sumDPT);

              let sumCollege = 0;
              data.payload.map((item) => {
                if (item.salaryAlowance == null) {
                  sumCollege += 0;
                } else {
                  sumCollege += parseInt(item?.salaryAlowance?.college);
                }
              });
              setTotalCollege(sumCollege);

              let sumHostel = 0;
              data.payload.map((item) => {
                if (item.salaryAlowance == null) {
                  sumHostel += 0;
                } else {
                  sumHostel += parseInt(item?.salaryAlowance?.hostel);
                }
              });
              setTotalHostel(sumHostel);

              let sumInvDuty = 0;
              data.payload.map((item) => {
                if (item.salaryAlowance == null) {
                  sumInvDuty += 0;
                } else {
                  sumInvDuty += parseInt(
                    item?.salaryAlowance?.invigilator_duty_allowance,
                  );
                }
              });
              setTotalInvDuty(sumInvDuty);

              let sumNavttc = 0;
              data.payload.map((item) => {
                if (item.salaryAlowance == null) {
                  sumNavttc += 0;
                } else {
                  sumNavttc += parseInt(item?.salaryAlowance?.navttc_allowance);
                }
              });
              setTotalNavttc(sumNavttc);

              let sumConvance = 0;
              data.payload.map((item) => {
                if (item.salaryAlowance == null) {
                  sumConvance += 0;
                } else {
                  sumConvance += parseInt(item?.salaryAlowance?.convance);
                }
              });
              setTotalConva(sumConvance);

              let sumInterDuty = 0;
              data.payload.map((item) => {
                if (item.salaryAlowance == null) {
                  sumInterDuty += 0;
                } else {
                  sumInterDuty += parseInt(
                    item?.salaryAlowance?.intermediate_allowance,
                  );
                }
              });
              setTotalInterAllow(sumInterDuty);

              let sumGrossSalary = 0;
              data.payload.map((item) => {
                if (item.pay_scale == null && item.salaryAlowance == null) {
                  sumGrossSalary += 0;
                } else {
                  sumGrossSalary +=
                    parseInt(item?.pay_scale?.basic) +
                    parseInt(item?.salaryAlowance?.all_allowance_total);
                }
              });
              setTotalGrossSalary(sumGrossSalary);

              // Change karna ha  all_allowance_total
              // let sumAnnualIncr = 0;
              // data.payload.map((item) => {
              //   if (item.pay_scale == null) {
              //     sumAnnualIncr += 0;
              //   } else {
              //     sumAnnualIncr += parseInt(item?.pay_scale?.increment);
              //   }
              // });
              // setTotalAnnualIncr(sumAnnualIncr);
              setReportData(data.payload);
            }
          }
        }),
      )

      .catch((err) => {
        setloading(false);
        console.log(err);
      });
  };

  function formatDate(inputDate) {
    const parts = inputDate.split("-");
    const month = parseInt(parts[1], 10);
    const year = parts[0];

    // Create an array of month names
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Get the full month name
    const fullMonth = monthNames[month - 1];

    // Format the result as "Month, Year"
    const formattedDate = `${fullMonth}, ${year}`;

    return formattedDate;
  }

  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row">
          <div className="col-md-4">
            <label>
              <b>Select Campus</b>
            </label>
            <div className="d-flex flex-column">
              <select
                style={{ height: 40 }}
                className="form-select"
                aria-label="Default select example"
                onChange={(e) => {
                  let res = campusData.find(
                    (item) => item.id == e.target.value,
                  );
                  setFullCampus(res);
                  setCampus(e.target.value);
                }}
              >
                <option value="">Select Campus</option>
                {campusData &&
                  campusData.map((item, index) => (
                    <option key={index} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="d-flex col-md-4">
            <button className="btn btn-primary mx-2 mt-9" onClick={onShow}>
              Show
            </button>
            {reportData.length > 0 && (
              <ReactToPrint
                pageStyle={pageStyle}
                documentTitle={`Gross Salary Sheet`}
                onAfterPrint={handleAfterPrint}
                onBeforeGetContent={handleOnBeforeGetContent}
                onBeforePrint={handleBeforePrint}
                removeAfterPrint={true}
                trigger={() => (
                  <button
                    disabled={printloading ? true : false}
                    style={{ marginLeft: "10px" }}
                    className="btn btn-primary mx-2 w-105px mt-9"
                  >
                    {printloading ? <span>Printing..</span> : "Print"}
                  </button>
                )}
                content={() => componentRef.current}
              />
            )}
            <div>
              {isVisible && (
                <GrossSalarySheetExport
                  reportData={reportData}
                  TotalBasicPay={TotalBasicPay}
                  TotalIncrement={TotalIncrement}
                  TotalBSAllow={TotalBSAllow}
                  TotalAdpAllow={TotalAdpAllow}
                  TotalAdditional={TotalAdditional}
                  TotalExtraPeriod={TotalExtraPeriod}
                  Total2ndShift={Total2ndShift}
                  TotalDPTAllow={TotalDPTAllow}
                  TotalCollege={TotalCollege}
                  TotalHostel={TotalHostel}
                  TotalInvDuty={TotalInvDuty}
                  TotalNavttc={TotalNavttc}
                  TotalConva={TotalConva}
                  TotalInterAllow={TotalInterAllow}
                  TotalGrossSalary={TotalGrossSalary}
                  // TotalAnnualIncr={TotalAnnualIncr}
                />
              )}
            </div>
          </div>
        </div>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spinner
              className="text-center"
              variant="info"
              animation="border"
            />
          </div>
        ) : (
          <div className="makeITScrollAAble mt-9">
            <Table
              style={{ width: "230%", marginTop: "15px", overflowY: "scroll" }}
              responsive
            >
              <thead>
                <tr
                  id="tbl"
                  style={{
                    position: "sticky",
                    top: "0",
                    zIndex: "2",
                    backgroundColor: "gainsboro",
                  }}
                >
                  <th className="text-center">Sr.No</th>
                  <th className="text-center">Code</th>
                  <th className="text-center">Name</th>
                  <th className="text-center">Designation</th>
                  <th className="text-center">Account No.</th>
                  <th className="text-center">Pay Scale</th>
                  <th className="text-center">Basic Pay</th>
                  <th className="text-center">Increment Total</th>
                  <th className="text-center">BS Allowance</th>
                  <th className="text-center">ADP Allowance</th>
                  <th className="text-center">Additional Allowance</th>
                  <th className="text-center">Extra Period Allowance</th>
                  <th className="text-center">2nd Shift Allowance</th>
                  <th className="text-center">DPT Allowance</th>
                  <th className="text-center">College Allowance</th>
                  <th className="text-center">Hostel Allowance</th>
                  <th className="text-center">Invigilator Duty Allowance</th>
                  <th className="text-center">Navttc Allowance</th>
                  <th className="text-center">Conv Allow</th>
                  <th className="text-center">Extra Coaching</th>
                  <th className="text-center">Gross Salary</th>
                  {/* <th className="text-center">Annual Increment</th> */}
                </tr>
              </thead>

              <tbody>
                {reportData.length > 0 &&
                  reportData.map((subitem, index) => (
                    <tr id="tbl" key={index}>
                      <td
                        style={{
                          color: "black",
                          backgroundColor: "white",
                        }}
                        className="text_align_center"
                      >
                        {index + 1}
                      </td>
                      <td
                        style={{
                          color: "black",
                          backgroundColor: "white",
                        }}
                        className="text_align_center"
                      >
                        {subitem.emp_code}
                      </td>
                      <td
                        style={{
                          color: "black",
                          backgroundColor: "white",
                        }}
                        className="text_align_center"
                      >
                        {subitem.full_name}
                      </td>

                      <td
                        style={{ color: "black" }}
                        className="text_align_center"
                      >
                        {subitem.designation?.name}
                      </td>

                      {subitem.account_no === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {"Not Define"}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.account_no}
                        </td>
                      )}

                      {subitem.pay_scale === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {"----"}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.pay_scale?.payscale}
                        </td>
                      )}

                      {subitem.pay_scale === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.pay_scale?.basic}
                        </td>
                      )}

                      {subitem.salaryAlowance === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.salaryAlowance?.increment}
                        </td>
                      )}

                      {subitem.salaryAlowance === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.salaryAlowance?.bs_allowance}
                        </td>
                      )}

                      {subitem.salaryAlowance === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.salaryAlowance?.adp_allowance}
                        </td>
                      )}

                      {subitem.salaryAlowance === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.salaryAlowance?.additional_allowance}
                        </td>
                      )}

                      {subitem.salaryAlowance === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.salaryAlowance?.extra_period}
                        </td>
                      )}

                      {subitem.salaryAlowance === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.salaryAlowance?.second_shift}
                        </td>
                      )}

                      {subitem.salaryAlowance === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.salaryAlowance?.dpt_allowance}
                        </td>
                      )}

                      {subitem.salaryAlowance === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.salaryAlowance?.college}
                        </td>
                      )}

                      {subitem.salaryAlowance === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.salaryAlowance?.hostel}
                        </td>
                      )}

                      {subitem.salaryAlowance === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.salaryAlowance?.invigilator_duty_allowance}
                        </td>
                      )}

                      {subitem.salaryAlowance === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.salaryAlowance?.navttc_allowance}
                        </td>
                      )}

                      {subitem.salaryAlowance === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.salaryAlowance?.convance}
                        </td>
                      )}

                      {subitem.salaryAlowance === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.salaryAlowance?.intermediate_allowance}
                        </td>
                      )}

                      {subitem.pay_scale === null &&
                      subitem.salaryAlowance == null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {"----"}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {parseInt(subitem.pay_scale?.basic) +
                            parseInt(
                              subitem.salaryAlowance?.all_allowance_total,
                            )}
                        </td>
                      )}

                      {/* Annual Increment */}
                      {/* {subitem.pay_scale === null ? (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {0}
                        </td>
                      ) : (
                        <td
                          style={{ color: "black" }}
                          className="text_align_center"
                        >
                          {subitem.pay_scale?.increment}
                        </td>
                      )} */}
                    </tr>
                  ))}
                {isVisible && (
                  <tr
                    id="tbl"
                    style={{
                      //   fontWeight: "bold",
                      backgroundColor: "gainsboro",
                    }}
                  >
                    <td colSpan={6} className="text_align_center text-primary">
                      Total
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalBasicPay}
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalIncrement}
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalBSAllow}
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalAdpAllow}
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalAdditional}
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalExtraPeriod}
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {Total2ndShift}
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalDPTAllow}
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalCollege}
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalHostel}
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalInvDuty}
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalNavttc}
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalConva}
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalInterAllow}
                    </td>
                    <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalGrossSalary}
                    </td>
                    {/* <td
                      style={{ color: "black" }}
                      className="text_align_center"
                    >
                      {TotalAnnualIncr}
                    </td> */}
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}

        <div ref={componentRef} id="printSection" className="customTablePrint">
          <div className="row p-3">
            <img style={{ height: 120, width: 120 }} src={icon} />

            <div className="col-md-6">
              <h1>{unitName}</h1>
              <h4>
                Gross Salary Sheet Of {fullCampus?.name} As Per {formattedDate}
              </h4>
              <h5>Printing Date: {displayDate}</h5>
            </div>
          </div>
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <td
                  className="text-center hereLineheighter"
                  style={{ border: "1px solid black" }}
                >
                  <b>Sr.No</b>
                </td>
                <td
                  className="text-center hereLineheighter"
                  style={{
                    border: "1px solid black",
                  }}
                >
                  <b>Code</b>
                </td>
                <td
                  className="text-center hereLineheighter"
                  style={{
                    border: "1px solid black",
                  }}
                >
                  {/* <p> */}
                  <b>Employee Name</b>
                  {/* </p> */}
                  {/* <br /> */}
                  {/* <p> */}
                  <b>Account No.</b>
                  {/* </p> */}
                </td>
                <td
                  className="text-center hereLineheighter"
                  style={{ border: "1px solid black" }}
                >
                  <b>Designation</b>
                  <br />
                  <b>Payscale</b>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{
                    border: "1px solid black",
                    // transform: "rotate(270deg)",
                    // maxWidth: "200px",
                    // height: "150px",
                  }}
                >
                  <p>
                    <b>Basic Pay</b>
                  </p>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{
                    border: "1px solid black",
                    // transform: "rotate(270deg)",
                    // maxWidth: "200px",
                    // height: "150px",
                  }}
                >
                  <p>
                    <b>Incr. Total</b>
                  </p>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{
                    border: "1px solid black",
                    // transform: "rotate(270deg)",
                    // maxWidth: "200px",
                    // height: "150px",
                  }}
                >
                  <p>
                    <b>BS Allow.</b>
                  </p>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{
                    border: "1px solid black",
                    // transform: "rotate(270deg)",
                    // maxWidth: "200px",
                    // height: "150px",
                  }}
                >
                  <p>
                    <b>ADP Allow.</b>
                  </p>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{ border: "1px solid black" }}
                >
                  <p>
                    <b>Add. Allow.</b>
                  </p>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{ border: "1px solid black" }}
                >
                  <p>
                    <b>Ext. Per. Allow.</b>
                  </p>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{ border: "1px solid black" }}
                >
                  <p>
                    <b>2nd Shift Allow.</b>
                  </p>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{ border: "1px solid black" }}
                >
                  <p>
                    <b>DPT Allow.</b>
                  </p>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{ border: "1px solid black" }}
                >
                  <p>
                    <b>College Allow.</b>
                  </p>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{ border: "1px solid black" }}
                >
                  <p>
                    <b>Hostel Allow.</b>
                  </p>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{ border: "1px solid black" }}
                >
                  <p>
                    <b>Inv. Duty Allow.</b>
                  </p>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{ border: "1px solid black" }}
                >
                  <p>
                    <b>Navttc Allow.</b>
                  </p>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{ border: "1px solid black" }}
                >
                  <p>
                    <b>Conva. Allow.</b>
                  </p>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{ border: "1px solid black" }}
                >
                  <p>
                    <b>Ext. Co. Allow.</b>
                  </p>
                </td>
                <td
                  className="hereLineheighter rotateIT"
                  style={{ border: "1px solid black" }}
                >
                  <p>
                    <b>Gross Salary</b>
                  </p>
                </td>
                {/* <td
                  className="text-center hereLineheighter rotateIT"
                  style={{ border: "1px solid black" }}
                >
                  <p>
                    <b>Annual Incre.</b>
                  </p>
                </td> */}
              </tr>
            </thead>

            <tbody>
              {reportData.length > 0 &&
                reportData.map((subitem, index) => (
                  <tr id="tbl" key={index}>
                    <td
                      style={{
                        color: "black",
                        border: "1px solid black",
                      }}
                      className="text_align_center"
                    >
                      {index + 1}
                    </td>
                    <td
                      style={{
                        color: "black",
                        border: "1px solid black",
                      }}
                      className="text_align_center"
                    >
                      {subitem.emp_code}
                    </td>
                    {subitem.account_no == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.full_name} <br />
                        {"Not Define"}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.full_name} <br /> {subitem.account_no}
                      </td>
                    )}

                    {subitem.pay_scale == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {"---"}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.designation?.name} <br />{" "}
                        {subitem.pay_scale?.payscale}
                      </td>
                    )}

                    {subitem.pay_scale == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.pay_scale?.basic}
                      </td>
                    )}

                    {subitem.salaryAlowance == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.salaryAlowance?.increment}
                      </td>
                    )}

                    {subitem.salaryAlowance == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.salaryAlowance?.bs_allowance}
                      </td>
                    )}

                    {subitem.salaryAlowance == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.salaryAlowance?.adp_allowance}
                      </td>
                    )}

                    {subitem.salaryAlowance == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.salaryAlowance?.additional_allowance}
                      </td>
                    )}

                    {subitem.salaryAlowance == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.salaryAlowance?.extra_period}
                      </td>
                    )}

                    {subitem.salaryAlowance == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.salaryAlowance?.second_shift}
                      </td>
                    )}

                    {subitem.salaryAlowance == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.salaryAlowance?.dpt_allowance}
                      </td>
                    )}

                    {subitem.salaryAlowance == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.salaryAlowance?.college}
                      </td>
                    )}

                    {subitem.salaryAlowance == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.salaryAlowance?.hostel}
                      </td>
                    )}

                    {subitem.salaryAlowance == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.salaryAlowance?.invigilator_duty_allowance}
                      </td>
                    )}

                    {subitem.salaryAlowance == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.salaryAlowance?.navttc_allowance}
                      </td>
                    )}

                    {subitem.salaryAlowance == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.salaryAlowance?.convance}
                      </td>
                    )}

                    {subitem.salaryAlowance == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.salaryAlowance?.intermediate_allowance}
                      </td>
                    )}

                    {subitem.pay_scale == null &&
                    subitem.salaryAlowance == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {parseInt(subitem.pay_scale?.basic) +
                          parseInt(subitem.salaryAlowance?.all_allowance_total)}
                      </td>
                    )}

                    {/* {subitem.pay_scale == null ? (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {0}
                      </td>
                    ) : (
                      <td
                        style={{ color: "black", border: "1px solid black" }}
                        className="text_align_center"
                      >
                        {subitem.pay_scale?.increment}
                      </td>
                    )} */}
                  </tr>
                ))}
              <tr
                id="tbl"
                // style={{
                //   //   fontWeight: "bold",
                //   backgroundColor: "gainsboro",
                // }}
              >
                {/* <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                ></td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                ></td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                ></td> */}
                <td
                  colSpan={4}
                  style={{
                    fontSize: "16px",
                    color: "black",
                    border: "1px solid black",
                  }}
                  className="text_align_center text-primary"
                >
                  <b>Total</b>
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalBasicPay}
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalIncrement}
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalBSAllow}
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalAdpAllow}
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalAdditional}
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalExtraPeriod}
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {Total2ndShift}
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalDPTAllow}
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalCollege}
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalHostel}
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalInvDuty}
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalNavttc}
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalConva}
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalInterAllow}
                </td>
                <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalGrossSalary}
                </td>
                {/* <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  {TotalAnnualIncr}
                </td> */}
                {/* <td
                  style={{ color: "black", border: "1px solid black" }}
                  className="text_align_center"
                >
                  ----
                </td> */}
              </tr>
            </tbody>
          </table>
          <div className="endTotalGlossNet">
            <div>
              <p>
                <b style={{ fontSize: "22px" }} className="text-primary">
                  Total Gross Salary:
                </b>{" "}
                <b style={{ fontSize: "22px" }}>{TotalGrossSalary}</b>
              </p>
            </div>
          </div>
        </div>
        {/* {loginAccount == "Campus" ? <PasswordModal /> : ""} */}
      </Paper>
    </>
  );
};

export default GrossSalarySheet;
